import React from 'react';
import { useInView } from 'react-intersection-observer';

import Obrazek from '../Zanimowane/Obrazek';
import AboutMeLewaStrona from '../AboutMeLewaStrona';


export default function SekcjaTrzy() {

    const { ref, inView } = useInView();

    return (

        <div className='flex justify-between' ref={ref}>
            <div>
                <AboutMeLewaStrona inView={inView} czyZanimowane={true} 
                button={true} link={"/portfolio/about"} tytul={"About me"} text={"Something about me and my skills"}/>
            </div>
                
            <div>
                <Obrazek referencja={inView} urlObrazka={"fala2.jpg"}/>
            </div>
            
        </div>

    )

}